module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div section=\"")
    ; __append(escapeFn( section.name ))
    ; __append("\" class='profile-tools-item section' on-click=\"onSectionClick\">\n    <div class='profile-tools-wrap'>\n        <div class='profile-tools-icon'>")
    ; __append( section.icon )
    ; __append("</div>\n        <div class='profile-tools-text'>")
    ; __append(escapeFn( section.title ))
    ; __append("</div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}